import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 1000,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoradadmdadosfaturamentoseplag(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoradadmdadosfaturamentoseplag/FIND_DATA':
      case '@operacaoradadmdadosfaturamentoseplag/UPDATE_DATA':
      case '@operacaoradadmdadosfaturamentoseplag/DELETE_DATA':
      case '@operacaoradadmdadosfaturamentoseplag/STORE_DATA':
      case '@operacaoradadmdadosfaturamentoseplag/DATA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaoradadmdadosfaturamentoseplag/SUCCESS_REMOVE':
      case '@operacaoradadmdadosfaturamentoseplag/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaoradadmdadosfaturamentoseplag/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoradadmdadosfaturamentoseplag/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.data;
        break;
      }

      case '@operacaoradadmdadosfaturamentoseplag/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 1000;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
